import { showroomApi } from '../services/api';

export const getCountries = async () => showroomApi.GET('/countries')({});

export const getCountriesQuery = async () => showroomApi.QUERY_GET('/countries')({});

export const getShippingCountries = async () => showroomApi.QUERY_GET('/countries-shipping')({});
